module.exports = __webpack_public_path__ + "static/img/alipay.c0436b5e.png";